/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Edit_TitleInputs */



/**
* | output |
* | --- |
* | "Edit Issue" |
*
* @param {Manual_Qc_Edit_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_edit_title = /** @type {((inputs?: Manual_Qc_Edit_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Edit_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier l'incident")
	if (locale === "de") return /** @type {LocalizedString} */ ("Problem bearbeiten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifica problema")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Редактировать проблему")
	if (locale === "es") return /** @type {LocalizedString} */ ("Editar problema")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("编辑问题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("問題を編集")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समस्या संपादित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Editar problema")
	return /** @type {LocalizedString} */ ("Edit Issue")
});